import {analyticsLogEvent} from '../api'

type LayerAction = 'open' | 'switch' | 'close'

interface Parameters {
    /** Name of the currently active tab (e.g. "Guida alle taglie" / "Come prendere le misure"). */
    tabName: string
    /** Interaction with the layer: open on first display, switch on tab change, close on dismiss. */
    action: LayerAction
}

/**
 * @name analyticsEventPdpSizeGuideLayer
 *
 * @event
 *
 * @description
 * Tracks the PDP size-guide drawer open/switch/close.
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.3.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'pdp_size_guide_layer', eventAction: '[TAB NAME]', eventLabel: 'open'|'switch'|'close' }`
 *
 * @remarks
 * This is distinct from the legacy `sizeChart` event (still emitted for backward compatibility);
 * the manual introduces the new `pdp_size_guide_layer` category for the PWA size-guide layer.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.tabName - Active tab name, mapped to `eventAction`.
 * @param {LayerAction} params.action - open/switch/close, mapped to `eventLabel`.
 */
export function analyticsEventPdpSizeGuideLayer({tabName, action}: Parameters) {
    analyticsLogEvent('custom_event', {
        eventCategory: 'pdp_size_guide_layer',
        eventAction: tabName,
        eventLabel: action,
    })
}
